import ApiModelWithAuth from "../../../models/ApiModelWithAuth";

// Чтение daily-логов скриптов (authorized/admin/logs/{channel}?date=) — LogsController.
// Ответ {channel, dates, date, lines} НЕ похож на CRUD-запись/список: formatterItem
// отключаем (иначе Formatter.Item налепит id/created_at/updated_at:null поверх).
export default class ApiLog extends ApiModelWithAuth {
    pathDef = 'authorized/admin/logs';
    formatterItem = null;

    // channel — один из LogsController::CHANNELS ('node-scripts'|'device-scripts'|
    // 'redroid-scripts'|'rbx-health'|'rbx-proxy'); date — 'YYYY-MM-DD' либо
    // пусто (бэкенд сам берёт последнюю доступную).
    static Index(channel, date = '') {
        const api = new this();
        api.__type = 'index';
        api.paths = { index: `authorized/admin/logs/${channel}` };
        api.__params = date ? { date } : {};
        return api;
    }
}
